import { render, staticRenderFns } from "./BadgeGroup.vue?vue&type=template&id=619753a7&"
import script from "./BadgeGroup.vue?vue&type=script&lang=ts&"
export * from "./BadgeGroup.vue?vue&type=script&lang=ts&"
import style0 from "./BadgeGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports